import { render, staticRenderFns } from "./editAssets.vue?vue&type=template&id=6c5d15eb&scoped=true&"
import script from "./editAssets.vue?vue&type=script&lang=js&"
export * from "./editAssets.vue?vue&type=script&lang=js&"
import style0 from "./editAssets.vue?vue&type=style&index=0&id=6c5d15eb&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c5d15eb",
  null
  
)

export default component.exports